import { create } from 'zustand';

// Interface pour les filtres du planning
export interface PlanningFilters {
  chantierIds: string[];      // Multi-sélection chantiers
  equipeIds: string[];        // Multi-sélection équipes
  searchQuery: string;        // Recherche texte libre
}

interface PlanningStore {
  isOpen: boolean;
  activeTab: 'planning' | 'equipes';
  selectedDate: Date | null;  // Date sélectionnée dans le planning
  // Filtres du planning
  filters: PlanningFilters;
  // Actions existantes
  openPanel: () => void;
  closePanel: () => void;
  togglePanel: () => void;
  setActiveTab: (tab: 'planning' | 'equipes') => void;
  setSelectedDate: (date: Date | null) => void;
  openPlanningToday: () => void;  // Ouvrir le planning à la date d'aujourd'hui
  // Actions filtres
  setSearchQuery: (query: string) => void;
  toggleChantierFilter: (chantierId: string) => void;
  toggleEquipeFilter: (equipeId: string) => void;
  clearFilters: () => void;
  removeChantierFilter: (chantierId: string) => void;
  removeEquipeFilter: (equipeId: string) => void;
}

const initialFilters: PlanningFilters = {
  chantierIds: [],
  equipeIds: [],
  searchQuery: '',
};

export const usePlanningStore = create<PlanningStore>((set) => ({
  isOpen: false,
  activeTab: 'planning',
  selectedDate: null,
  filters: initialFilters,
  openPanel: () => set({ isOpen: true }),
  closePanel: () => set({ isOpen: false }),
  togglePanel: () => set((state) => ({ isOpen: !state.isOpen })),
  setActiveTab: (tab) => set({ activeTab: tab }),
  setSelectedDate: (date) => set({ selectedDate: date }),
  openPlanningToday: () => set({ isOpen: true, activeTab: 'planning', selectedDate: new Date() }),
  // Actions filtres
  setSearchQuery: (query) => set((state) => ({
    filters: { ...state.filters, searchQuery: query }
  })),
  toggleChantierFilter: (chantierId) => set((state) => {
    const current = state.filters.chantierIds;
    const newIds = current.includes(chantierId)
      ? current.filter(id => id !== chantierId)
      : [...current, chantierId];
    return { filters: { ...state.filters, chantierIds: newIds } };
  }),
  toggleEquipeFilter: (equipeId) => set((state) => {
    const current = state.filters.equipeIds;
    const newIds = current.includes(equipeId)
      ? current.filter(id => id !== equipeId)
      : [...current, equipeId];
    return { filters: { ...state.filters, equipeIds: newIds } };
  }),
  clearFilters: () => set({ filters: initialFilters }),
  removeChantierFilter: (chantierId) => set((state) => ({
    filters: {
      ...state.filters,
      chantierIds: state.filters.chantierIds.filter(id => id !== chantierId)
    }
  })),
  removeEquipeFilter: (equipeId) => set((state) => ({
    filters: {
      ...state.filters,
      equipeIds: state.filters.equipeIds.filter(id => id !== equipeId)
    }
  })),
}));
